import { Link } from "react-router-dom";
import { ABOUT_CONTENT, CONTACT_INFO } from "../utils/constants";
import useDocumentMeta from "../utils/useDocumentMeta";

const About = () => {
    useDocumentMeta(
        "About Manoj Kumar | 20+ Years Financial Consultant | PVM Consultants",
        "Manoj Kumar has 20+ years of experience managing investments, insurance, tax filing and loans for working professionals, with ₹5 Cr+ in client assets currently managed."
    );

    return (
        <section className="about-page">
            <div className="about-hero">
                <div className="about-photo">
                    <div className="avatar-placeholder">MK</div>
                </div>
                <div className="about-intro">
                    <span className="eyebrow">About</span>
                    <h1>{CONTACT_INFO.consultantName}</h1>
                    <p className="about-tagline">Financial Consultant &middot; 20+ Years of Experience</p>
                    <p>{ABOUT_CONTENT.intro}</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                    </Link>
                </div>
            </div>

            <div className="about-body">
                {ABOUT_CONTENT.paragraphs.map((para, idx) => (
                    <p key={idx}>{para}</p>
                ))}
            </div>

            <div className="about-highlights">
                {ABOUT_CONTENT.highlights.map((item) => (
                    <div className="highlight-pill" key={item}>
                        {item}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default About;
